export const mbtiDetails = {
  'ISTJ': {
    analysis: `당신은 체계적이고 책임감이 강한 현실주의자입니다. 주기능인 내향적 감각(Si)으로 인해 과거의 경험과 전통적인 방식을 중요하게 여기며 이를 통해 현재를 판단합니다. 보조기능인 외향적 사고(Te)는 논리적이고 객관적인 판단을 선호하며, 효율적인 시스템 구축을 추구하게 만듭니다.

SJ 기질(감독자형)의 특성이 강하게 나타나, 안정성과 질서를 매우 중요시합니다. 다른 SJ들처럼 책임감과 의무감이 강하며, 특히 전통과 규칙을 준수하는 것을 중요하게 생각합니다. 체계적이고 단계적인 접근을 선호하며, 안정된 환경에서 자신의 역량을 가장 잘 발휘합니다.

실제 생활에서는 정확하고 철저한 업무 처리 능력이 돋보입니다. 예를 들어, 프로젝트 관리에서 세부 일정과 자원을 꼼꼼하게 계획하고, 정해진 절차와 규칙을 철저히 준수하며 진행합니다. 또한 자신의 책임 영역에서는 신뢰할 수 있는 결과물을 만들어내는 것으로 정평이 나 있습니다.

하지만 갑작스러운 변화나 불확실한 상황에서는 큰 스트레스를 받습니다. 특히 기존의 방식이나 규칙이 무시될 때, 또는 즉흥적인 계획 변경이 필요할 때 불안감을 느낍니다. 또한 새로운 아이디어나 혁신적인 방법을 시도하는 것을 어려워하며, 때로는 지나치게 완고하거나 경직되어 보일 수 있습니다.`,
    development: [
      "새로운 아이디어와 변화를 더 열린 마음으로 받아들이도록 노력해보세요",
      "계획이 변경되더라도 유연하게 대처하는 능력을 기르세요",
      "다른 사람의 감정과 관점도 중요하게 고려해보세요",
      "때로는 완벽함보다 효율성을 선택하는 것도 필요합니다"
    ]
  },

  'ISFJ': {
    analysis: `당신은 따뜻하고 헌신적인 보호자입니다. 주기능인 내향적 감각(Si)은 과거의 경험을 소중히 여기며 세부사항에 주의를 기울이게 만듭니다. 보조기능인 외향적 감정(Fe)으로 인해 다른 사람들의 필요와 감정에 민감하게 반응하며 조화로운 관계를 추구합니다.

SJ 기질(감독자형)의 특성으로 안정성과 전통을 중시하지만, 다른 SJ 유형들과 달리 사람들의 감정적 안녕에 더 큰 관심을 가집니다. 책임감과 의무감이 강하며, 특히 자신이 돌보는 사람들의 필요를 섬세하게 파악하고 충족시키는 데 탁월합니다.

일상생활에서는 다른 사람을 돕고 보살피는 역할을 자연스럽게 맡게 됩니다. 예를 들어, 직장에서 동료들의 고민을 잘 들어주고 실질적인 도움을 제공하거나, 가정에서 가족 구성원들의 선호도를 정확히 기억하고 배려하는 모습을 보입니다. 또한 맡은 일을 꼼꼼하고 성실하게 처리하며, 안정적인 환경 조성을 위해 노력합니다.

그러나 자신의 필요나 감정은 뒤로 한 채 타인을 위해 지나치게 희생하는 경향이 있습니다. 특히 갈등 상황이나 부정적인 피드백을 받을 때 큰 스트레스를 받으며, 변화나 새로운 상황에 적응하는 것을 어려워합니다. 또한 완벽주의적 성향으로 인해 자신에게 너무 가혹한 기준을 적용하는 경우가 많습니다.`,
    development: [
      "자신의 욕구와 감정도 중요하게 여기고 표현하세요",
      "모든 상황을 완벽하게 통제하려 하지 말고 여유를 가지세요",
      "변화를 두려워하지 말고 새로운 경험을 시도해보세요",
      "다른 사람의 부탁을 거절하는 것도 때로는 필요합니다"
    ]
  },

  'INFJ': {
    analysis: `당신은 통찰력 있고 이상주의적인 중재자입니다. 주기능인 내향적 직관(Ni)으로 인해 복잡한 패턴을 직관적으로 파악하고 미래에 대한 깊은 통찰을 얻습니다. 보조기능인 외향적 감정(Fe)은 다른 사람들의 감정과 필요에 민감하게 반응하며, 조화로운 관계를 추구하게 만듭니다.

NF 기질(이상가형)의 특성이 강하게 나타나, 인간의 성장과 자아실현에 깊은 관심을 가집니다. 다른 NF들처럼 의미 있는 관계와 가치를 추구하지만, 특히 더 깊은 통찰과 완벽한 이상을 추구하는 경향이 있습니다. 자신과 타인의 잠재력을 끌어내는 데 탁월하며, 더 나은 세상을 만들고자 하는 강한 사명감을 가지고 있습니다.

실제 생활에서는 사람들의 숨겨진 동기와 감정을 예리하게 파악합니다. 예를 들어, 팀 내 갈등 상황에서 각 구성원의 진짜 걱정거리를 파악하고 효과적으로 중재하거나, 상담이나 코칭 상황에서 상대방의 잠재력을 알아보고 성장을 도울 수 있습니다. 또한 복잡한 문제에 대해 창의적이고 통찰력 있는 해결책을 제시하는 능력이 있습니다.

하지만 완벽주의적 성향과 높은 이상으로 인해 자신과 타인에게 지나치게 높은 기준을 적용할 수 있습니다. 특히 자신의 직관에 지나치게 의존하여 현실적인 세부사항을 놓치거나, 다른 사람들의 기대에 부응하지 못할 것 같은 불안감에 시달릴 수 있습니다. 또한 타인의 부정적인 감정을 깊이 흡수하여 정서적 소진을 경험하기도 합니다.`,
    development: [
      "현실적인 한계와 불완전함을 받아들이는 연습을 하세요",
      "자신의 직관만큼 구체적인 사실도 중요하게 고려하세요",
      "타인의 감정과 적절한 거리를 유지하는 법을 배우세요",
      "완벽주의적 성향을 조절하고 자신에게 더 관대해지세요"
    ]
  },

  'INFP': {
    analysis: `당신은 이상적이고 창의적인 중재자입니다. 주기능인 내향적 감정(Fi)으로 인해 강한 개인적 가치관과 진정성을 추구하며, 깊은 감정의 세계를 가지고 있습니다. 보조기능인 외향적 직관(Ne)은 다양한 가능성을 탐색하고 창의적인 아이디어를 생성하게 만듭니다.

NF 기질(이상가형)의 특성으로 인해 인간의 잠재력과 자아실현에 깊은 관심을 가집니다. 다른 NF들처럼 의미 있는 가치와 진정성을 추구하지만, 특히 개인의 고유성과 내면의 조화를 중요시합니다. 자신과 타인의 감정을 깊이 이해하고, 이상적인 세상을 꿈꾸며 창작 활동을 통해 이를 표현하려는 경향이 있습니다.

일상생활에서는 깊은 공감 능력과 창의성이 돋보입니다. 예를 들어, 친구가 겪는 어려움에 대해 진심 어린 이해와 위로를 제공하거나, 예술적 활동이나 글쓰기를 통해 자신만의 독특한 시각을 표현합니다. 또한 타인의 잠재력을 알아보고 그들의 성장을 돕는 데 탁월한 능력을 보입니다.

그러나 현실의 제약이나 일상적인 의무를 다루는 데 어려움을 느낄 수 있습니다. 특히 자신의 이상과 현실 사이의 괴리로 인한 좌절감을 자주 경험하며, 타인의 기대나 사회적 규범에 맞추는 것을 힘들어합니다. 또한 자기비판적 성향이 강해 자신의 결정이나 능력을 끊임없이 의심하는 경향이 있습니다.`,
    development: [
      "현실적인 목표 설정과 실행 계획을 세우는 습관을 기르세요",
      "지나친 자기비판을 줄이고 자신의 강점을 인정하세요",
      "일상적인 책임과 의무도 중요하게 여기세요",
      "결정을 미루지 말고 적절한 시기에 실행에 옮기세요"
    ]
  },

  'ESTP': {
    analysis: `당신은 활동적이고 현실적인 모험가입니다. 주기능인 외향적 감각(Se)으로 인해 현재 순간의 경험과 기회를 민첩하게 포착하며, 즉각적인 행동으로 옮기는 것을 선호합니다. 보조기능인 내향적 사고(Ti)는 상황을 논리적으로 분석하고 효율적인 해결책을 찾아내게 합니다.

SP 기질(탐험가형)의 특성이 강하게 나타나, 자유롭고 실용적인 행동을 추구합니다. 다른 SP들처럼 즉각적인 경험과 실제적인 결과를 중요시하지만, 특히 위기 상황이나 도전적인 과제에서 뛰어난 문제 해결 능력을 보입니다. 규칙이나 관습에 얽매이지 않고 상황에 따라 유연하게 대처하는 것을 선호합니다.

실제 생활에서는 빠른 상황 판단과 실행력이 돋보입니다. 예를 들어, 긴급한 문제가 발생했을 때 신속하게 해결책을 찾아내거나, 협상 상황에서 상대방의 반응을 정확히 읽고 효과적으로 대응합니다. 또한 새로운 기술이나 도구를 다루는 데 있어 탁월한 적응력을 보여줍니다.

하지만 장기적인 계획이나 추상적인 개념을 다루는 것을 어려워할 수 있습니다. 특히 미래에 대한 준비나 체계적인 계획 수립을 소홀히 하는 경향이 있으며, 타인의 감정적 필요나 관계의 섬세한 측면을 간과할 수 있습니다. 또한 즉각적인 결과나 흥미를 추구하다 보니 책임감 있는 결정이나 일의 마무리를 소홀히 할 수 있습니다.`,
    development: [
      "장기적인 계획과 목표 설정의 중요성을 인식하세요",
      "타인의 감정과 관계적 측면에도 주의를 기울이세요",
      "위험을 감수하기 전에 결과를 신중히 고려하세요",
      "시작한 일은 책임감 있게 마무리하는 습관을 기르세요"
    ]
  },

  'ESFP': {
    analysis: `당신은 활기차고 자유로운 영혼의 연예인입니다. 주기능인 외향적 감각(Se)으로 인해 현재의 순간을 충실히 즐기며, 주변 환경의 변화에 민감하게 반응합니다. 보조기능인 내향적 감정(Fi)은 강한 개인적 가치관과 진정성 있는 감정 표현으로 나타납니다.

SP 기질(탐험가형)의 특성으로 자유롭고 즉흥적인 삶을 추구합니다. 다른 SP들처럼 현재의 경험과 즐거움을 중시하지만, 특히 사람들과의 교류와 감정적 교감을 통해 에너지를 얻습니다. 규칙이나 제약에 얽매이지 않고 자연스러운 표현과 행동을 선호합니다.

일상생활에서는 타고난 사교성과 낙관적인 에너지가 돋보입니다. 예를 들어, 모임이나 파티에서 분위기를 활기차게 만들거나, 어색한 상황을 유머러스하게 풀어내는 능력이 탁월합니다. 또한 다른 사람의 감정을 잘 읽고 즉각적으로 공감하며, 실질적인 도움을 제공하는 것을 좋아합니다.

그러나 장기적인 계획이나 체계적인 접근을 필요로 하는 상황에서 어려움을 겪을 수 있습니다. 특히 미래에 대한 준비나 재정 관리와 같은 실용적인 측면을 소홀히 하는 경향이 있으며, 즐거운 경험을 추구하다가 중요한 책임을 미루거나 잊어버릴 수 있습니다. 또한 갈등이나 부정적인 상황을 회피하려는 성향이 있어 깊이 있는 관계 형성에 어려움을 겪을 수 있습니다.`,
    development: [
      "장기적인 목표를 설정하고 체계적인 계획을 세우세요",
      "재정 관리와 같은 실용적인 책임도 중요하게 다루세요",
      "즐거움 추구와 의무 이행 사이의 균형을 찾으세요",
      "갈등을 회피하지 말고 건설적으로 해결하는 법을 배우세요"
    ]
  },

  'ENFP': {
    analysis: `당신은 열정적이고 창의적인 자유로운 영혼입니다. 주기능인 외향적 직관(Ne)으로 인해 새로운 가능성과 패턴을 빠르게 발견하며, 혁신적인 아이디어를 끊임없이 생성합니다. 보조기능인 내향적 감정(Fi)은 강한 개인적 가치관과 진정성 있는 자기표현으로 나타납니다.

NF 기질(이상가형)의 특성이 강하게 나타나, 인간의 잠재력과 자아실현에 깊은 관심을 가집니다. 다른 NF들처럼 의미 있는 관계와 자아실현을 추구하지만, 특히 새로운 가능성을 발견하고 다른 사람들에게 영감을 주는 것에 탁월합니다. 독창적인 시각과 열정적인 에너지로 주변 사람들을 동기부여하고 변화를 이끌어냅니다.

일상생활에서는 뛰어난 창의성과 사교성이 돋보입니다. 예를 들어, 팀 프로젝트에서 혁신적인 아이디어를 제시하거나, 사람들 간의 갈등을 창의적으로 해결하는 능력이 탁월합니다. 또한 다양한 사람들과 쉽게 교감하며, 그들의 잠재력을 발견하고 성장을 돕는 것을 즐깁니다.

하지만 너무 많은 가능성을 동시에 추구하다 보니 집중력과 지속성이 부족할 수 있습니다. 특히 일상적인 업무나 세부적인 계획 실행에 어려움을 겪으며, 마감 시간이나 체계적인 관리가 필요한 상황에서 스트레스를 받습니다. 또한 다른 사람들의 인정과 호감을 중요시하여 필요한 충돌이나 갈등을 회피하는 경향이 있으며, 자신의 한계를 인정하지 않고 과도하게 에너지를 소진할 수 있습니다.`,
    development: [
      "하나의 프로젝트에 집중하여 완수하는 습관을 기르세요",
      "현실적인 계획 수립과 실행에 더 많은 노력을 기울이세요",
      "자신의 에너지와 시간의 한계를 인정하고 관리하세요",
      "필요한 경우 건설적인 갈등도 피하지 말고 마주하세요"
    ]
  },

  'ENFJ': {
    analysis: `당신은 카리스마 있고 영감을 주는 지도자입니다. 주기능인 외향적 감정(Fe)으로 인해 다른 사람들의 감정과 필요를 민감하게 파악하고 조화로운 관계를 구축합니다. 보조기능인 내향적 직관(Ni)은 사람과 상황에 대한 깊은 통찰력을 제공합니다.

NF 기질(이상가형)의 특성으로 인간의 성장과 발전에 깊은 관심을 가집니다. 다른 NF들처럼 의미 있는 가치 실현을 추구하지만, 특히 집단의 조화와 공동의 성장을 이끌어내는 데 탁월합니다. 사람들의 잠재력을 발견하고 개발하는 것에 큰 만족을 느끼며, 이상적인 비전을 현실화하기 위해 적극적으로 행동합니다.

실제 생활에서는 뛰어난 대인관계 능력과 리더십이 돋보입니다. 예를 들어, 팀원들의 다양한 의견을 조율하여 합의점을 도출하거나, 조직의 비전을 구성원들에게 효과적으로 전달하고 동기부여하는 능력이 탁월합니다. 또한 갈등 상황에서 각 당사자의 입장을 이해하고 건설적인 해결책을 제시합니다.

그러나 다른 사람들의 필요와 감정에 지나치게 몰입하여 자신의 욕구를 무시할 수 있습니다. 특히 모든 사람을 만족시키려 노력하다가 정작 자신의 건강이나 행복을 소홀히 하는 경향이 있으며, 갈등을 피하기 위해 중요한 결정을 미루거나 타협할 수 있습니다. 또한 완벽주의적 성향으로 인해 자신과 타인에게 과도한 기대를 하는 경우가 많습니다.`,
    development: [
      "자신의 필요와 감정도 중요하게 여기고 표현하세요",
      "모든 사람을 만족시키려 하기보다 건강한 경계를 설정하세요",
      "때로는 갈등이 필요하고 자연스러운 것임을 인정하세요",
      "자신과 타인에 대한 완벽주의적 기대를 조절하세요"
    ]
  },

  'ENTP': {
    analysis: `당신은 혁신적이고 독창적인 발명가입니다. 주기능인 외향적 직관(Ne)으로 인해 새로운 가능성과 연결점을 빠르게 발견하며, 기존의 틀을 벗어난 혁신적인 아이디어를 생성합니다. 보조기능인 내향적 사고(Ti)는 논리적 일관성을 추구하며 복잡한 문제를 분석하게 만듭니다.

NT 기질(분석가형)의 특성이 강하게 나타나, 지적 도전과 혁신을 추구합니다. 다른 NT들처럼 논리와 지식을 중시하지만, 특히 기존 시스템의 한계를 발견하고 새로운 가능성을 탐구하는 것을 즐깁니다. 지적인 토론을 통해 아이디어를 발전시키며, 문제 해결에 있어 창의적이고 도전적인 접근을 선호합니다.

일상생활에서는 뛰어난 분석력과 기민한 통찰력이 돋보입니다. 예를 들어, 복잡한 문제에 대해 독창적인 해결책을 제시하거나, 브레인스토밍 세션에서 다양한 아이디어를 연결하여 새로운 관점을 제시합니다. 또한 재치 있는 언변으로 사람들과 지적인 교류를 즐기며, 때로는 논쟁을 통해 진실을 탐구합니다.

하지만 새로운 아이디어에 너무 몰두한 나머지 실행과 마무리가 부족할 수 있습니다. 특히 일상적인 업무나 사회적 의무를 소홀히 하는 경향이 있으며, 감정적 교류나 대인관계 형성에 불편함을 느낍니다. 또한 완벽한 해결책을 찾으려는 성향 때문에 결정을 미루거나, 자신의 아이디어를 실현하는 단계에서 주저하는 모습을 보일 수 있습니다.`,
    development: [
      "이론적 탐구와 실제 적용의 균형을 맞추도록 노력하세요",
      "프로젝트를 끝까지 완수하는 습관을 기르세요",
      "감정 표현과 공감 능력을 개발하려 노력하세요",
      "중요한 일은 미루지 말고 책임감 있게 처리하세요",
      "팀워크와 협력의 가치를 인정하고 실천하세요"
    ]
  },

  'ENTJ': {
    analysis: `당신은 대담하고 결단력 있는 지도자입니다. 주기능인 외향적 사고(Te)로 인해 논리적이고 효율적인 시스템을 구축하며, 목표 달성을 위해 체계적으로 행동합니다. 보조기능인 내향적 직관(Ni)은 장기적인 비전과 전략적 통찰력을 제공합니다.

NT 기질(분석가형)의 특성으로 합리성과 효율성을 최우선시합니다. 다른 NT들처럼 지식과 역량을 중시하지만, 특히 이를 실제 성과와 결과로 연결시키는 것에 탁월합니다. 명확한 목표 설정과 전략적 계획 수립을 통해 조직을 이끌며, 혁신과 성과 창출에 강한 의지를 보입니다.

실제 생활에서는 뛰어난 리더십과 실행력이 돋보입니다. 예를 들어, 복잡한 프로젝트를 체계적으로 관리하거나, 조직의 규칙과 절차를 명확히 정립하여 안정적인 운영을 가능하게 합니다. 또한 직접적이고 명확한 의사소통으로 업무의 효율성을 높입니다.

그러나 자신의 높은 기준과 완벽주의적 성향으로 인해 타인과의 협업에서 어려움을 겪을 수 있습니다. 특히 감정적인 교류나 일상적인 사교 활동을 불필요하게 여기는 경향이 있으며, 다른 사람들의 비효율적인 업무 방식이나 논리적이지 않은 결정에 강한 불만을 느낍니다. 또한 자신의 비전을 타인과 효과적으로 공유하는 것을 어려워할 수 있습니다.`,
    development: [
      "다른 사람들의 감정과 개인적 상황에 더 많은 이해를 보이세요",
      "새로운 아이디어와 방식에 대해 더 열린 태도를 가지세요",
      "규칙과 절차에 융통성을 발휘하는 법을 배우세요",
      "비판이나 조언을 더 부드럽게 전달하는 방법을 익히세요",
      "다른 사람들과의 협업과 소통에 더 많은 관심을 기울이세요",
      "즉흥적인 상황이나 계획의 변경도 수용하는 법을 배우세요"
    ]
  },

  'ESTJ': {
    analysis: `당신은 체계적이고 실용적인 관리자입니다. 주기능인 외향적 사고(Te)로 인해 논리적이고 효율적인 시스템을 구축하며, 명확한 규칙과 절차를 중시합니다. 보조기능인 내향적 감각(Si)은 과거의 경험과 전통적인 방식을 통해 현재를 판단하게 합니다.

SJ 기질(감독자형)의 특성이 강하게 나타나, 질서와 안정성을 추구합니다. 다른 SJ들처럼 책임감과 의무감이 강하지만, 특히 효율적인 조직 운영과 목표 달성에 탁월합니다. 명확한 기준과 체계적인 접근을 통해 조직을 이끌며, 실질적인 결과를 중시합니다.

실제 생활에서는 뛰어난 조직력과 실행력이 돋보입니다. 예를 들어, 복잡한 프로젝트를 체계적으로 분류하고 효율적으로 관리하거나, 조직의 규칙과 절차를 명확히 정립하여 안정적인 운영을 가능하게 합니다. 또한 직접적이고 명확한 의사소통으로 업무의 효율성을 높입니다.

하지만 때로는 지나치게 통제적이고 경직되어 보일 수 있습니다. 특히 다른 사람들의 감정이나 개인적 상황을 고려하지 않고 규칙과 절차만을 강조하는 경향이 있으며, 새로운 아이디어나 변화에 대해 저항적일 수 있습니다. 또한 자신의 판단이 항상 옳다고 믿어 다른 관점을 수용하는 데 어려움을 겪을 수 있습니다.`,
    development: [
      "다른 사람들의 감정과 개인적 상황에 더 많은 이해를 보이세요",
      "새로운 아이디어와 방식에 대해 더 열린 태도를 가지세요",
      "규칙과 절차에 융통성을 발휘하는 법을 배우세요",
      "비판이나 조언을 더 부드럽게 전달하는 방법을 익히세요",
      "다른 사람들과의 협업과 소통에 더 많은 관심을 기울이세요",
      "즉흥적인 상황이나 계획의 변경도 수용하는 법을 배우세요"
    ]
  },

  'ESFJ': {
    analysis: `당신은 친절하고 배려심 깊은 사교가입니다. 주기능인 외향적 감정(Fe)으로 인해 다른 사람들의 필요와 감정을 민감하게 파악하고 조화로운 관계를 추구합니다. 보조기능인 내향적 감각(Si)은 전통과 경험을 중시하며 안정성을 추구하게 만듭니다.

SJ 기질(감독자형)의 특성으로 책임감과 의무감이 강합니다. 다른 SJ들처럼 안정성과 질서를 중시하지만, 특히 인간관계의 조화와 타인에 대한 봉사를 중요하게 여깁니다. 사회적 규범과 전통을 존중하며, 공동체의 화합을 위해 헌신적으로 노력합니다.

일상생활에서는 뛰어난 대인관계 능력과 실용적인 봉사 정신이 돋보입니다. 예를 들어, 팀 내 갈등을 조기에 감지하고 해결하거나, 구성원들의 필요를 세심하게 파악하여 실질적인 도움을 제공합니다. 또한 조직의 전통과 문화를 잘 이해하고 유지하는 데 기여합니다.

그러나 다른 사람들의 인정과 조화를 너무 중시한 나머지 자신의 욕구를 무시할 수 있습니다. 특히 갈등을 피하기 위해 자신의 의견을 억누르거나, 타인의 기대에 지나치게 부응하려 노력하는 경향이 있습니다. 또한 변화나 새로운 상황에 대한 두려움이 있어, 익숙한 방식을 고수하려 할 수 있습니다.`,
    development: [
      "자신의 욕구와 감정도 중요하게 여기고 표현하세요",
      "모든 상황에서 조화만을 추구하지 말고 건강한 갈등도 수용하세요",
      "변화를 두려워하지 말고 새로운 경험을 시도해보세요",
      "다른 사람의 인정에 덜 의존하고 자신을 더 신뢰하세요"
    ]
  },

  'ISTP': {
    analysis: `당신은 논리적이고 실용적인 문제 해결사입니다. 주기능인 내향적 사고(Ti)로 인해 논리적 분석과 체계적인 이해를 추구하며, 보조기능인 외향적 감각(Se)은 현재의 상황에 민첩하게 대응하고 실제적인 경험을 중시하게 만듭니다.

SP 기질(탐험가형)의 특성이 강하게 나타나, 실용적이고 적응력이 뛰어납니다. 다른 SP들처럼 자유와 융통성을 중시하지만, 특히 기계적 원리나 시스템의 작동 방식을 이해하고 다루는 데 탁월한 능력을 보입니다. 위기 상황에서 침착하게 대처하며, 효율적인 문제 해결을 추구합니다.

일상생활에서는 실제적인 문제 해결 능력이 돋보입니다. 예를 들어, 복잡한 기계나 시스템을 직접 분해하고 조립하면서 작동 원리를 파악하거나, 긴급한 상황에서 신속하고 정확한 판단으로 문제를 해결합니다. 또한 불필요한 규칙이나 제약에 얽매이지 않고 자유롭게 일하는 것을 선호합니다.

하지만 장기적인 계획이나 미래에 대한 준비를 소홀히 할 수 있습니다. 특히 감정적인 표현이나 타인과의 정서적 교류를 어려워하며, 일상적인 책임이나 의무를 미루는 경향이 있습니다. 또한 즉흥적인 결정으로 인해 중요한 기회를 놓치거나, 타인의 감정을 고려하지 않은 직설적인 표현으로 관계에 어려움을 겪을 수 있습니다.`,
    development: [
      "장기적인 목표를 설정하고 계획적으로 행동하세요",
      "감정 표현과 공감 능력을 개발하려 노력하세요",
      "중요한 일은 미루지 말고 책임감 있게 처리하세요",
      "팀워크와 협력의 가치를 인정하고 실천하세요"
    ]
  },

  'ISFP': {
    analysis: `당신은 예술적이고 감성적인 탐험가입니다. 주기능인 내향적 감정(Fi)으로 인해 강한 개인적 가치관과 진정성을 추구하며, 보조기능인 외향적 감각(Se)은 현재의 경험과 감각적인 아름다움을 중요시하게 만듭니다.

SP 기질(탐험가형)의 특성으로 자유롭고 유연한 삶을 추구합니다. 다른 SP들처럼 현재의 순간을 즐기지만, 특히 예술적 표현과 개인적 가치를 통해 자신을 실현하려는 경향이 강합니다. 타인의 감정에 민감하게 반응하며, 조화로운 환경을 만드는 데 탁월합니다.

일상생활에서는 섬세한 미적 감각과 실용적인 창의성이 돋보입니다. 예를 들어, 공간을 아름답게 꾸미거나 예술적 작품을 만드는 데 재능을 보이며, 다른 사람의 감정적 필요를 직관적으로 파악하고 적절히 반응합니다. 또한 자신만의 독특한 스타일과 표현 방식을 가지고 있습니다.

그러나 자신의 의견이나 감정을 적극적으로 표현하는 것을 어려워합니다. 특히 갈등 상황을 피하려는 경향이 있으며, 중요한 결정을 미루거나 장기적인 계획을 세우는 것을 불편해합니다. 또한 타인의 비판에 지나치게 민감하게 반응하여 자신의 잠재력을 충분히 발휘하지 못할 수 있습니다.`,
    development: [
      "자신의 의견과 감정을 더 적극적으로 표현하세요",
      "장기적인 목표를 설정하고 계획적으로 행동하세요",
      "갈등을 회피하지 말고 건설적으로 해결하세요",
      "비판을 두려워하지 말고 성장의 기회로 받아들이세요"
    ]
  },

  'INTP': {
    analysis: `당신은 논리적이고 창의적인 사색가입니다. 주기능인 내향적 사고(Ti)로 인해 논리적 일관성과 정확성을 추구하며, 복잡한 문제를 분석하고 이해하는 것을 즐깁니다. 보조기능인 외향적 직관(Ne)은 다양한 가능성을 탐색하고 독창적인 해결책을 생성하게 만듭니다.

NT 기질(분석가형)의 특성으로 지적 호기심과 논리적 탐구를 중요시합니다. 다른 NT들처럼 지식과 이해를 추구하지만, 특히 이론적 개념과 추상적 모델을 탐구하는 것을 선호합니다. 기존의 시스템이나 이론의 논리적 허점을 발견하고 개선하는 것에 탁월한 능력을 보입니다.

일상생활에서는 문제 해결에 대한 독창적인 접근이 돋보입니다. 예를 들어, 복잡한 기술적 문제에 대해 새로운 관점에서 해결책을 제시하거나, 기존 시스템의 개선점을 논리적으로 분석하여 더 효율적인 방안을 도출합니다. 또한 지적 토론을 통해 아이디어를 발전시키는 것을 즐깁니다.

그러나 이론적 탐구에 몰두한 나머지 실제 실행이나 프로젝트 완수에 어려움을 겪을 수 있습니다. 특히 일상적인 업무나 사회적 의무를 소홀히 하는 경향이 있으며, 감정적 교류나 대인관계 형성에 불편함을 느낍니다. 또한 완벽한 해결책을 찾으려는 성향 때문에 결정을 미루거나, 자신의 아이디어를 실현하는 단계에서 주저하는 모습을 보일 수 있습니다.`,
    development: [
      "이론적 탐구와 실제 적용의 균형을 맞추도록 노력하세요",
      "프로젝트를 끝까지 완수하는 습관을 기르세요",
      "감정 표현과 공감 능력을 개발하려 노력하세요",
      "중요한 일은 미루지 말고 책임감 있게 처리하세요",
      "팀워크와 협력의 가치를 인정하고 실천하세요"
    ]
  },

  'INTJ': {
    analysis: `당신은 전략적이고 혁신적인 전략가입니다. 주기능인 내향적 직관(Ni)으로 인해 복잡한 시스템을 직관적으로 이해하고 미래의 가능성을 예측하는 능력이 뛰어납니다. 보조기능인 외향적 사고(Te)는 논리적이고 효율적인 시스템을 구축하려는 성향으로 나타납니다.

NT 기질(분석가형)의 특성으로 합리성과 효율성을 최우선시합니다. 다른 NT들처럼 지식과 역량 개발을 추구하지만, 특히 장기적인 비전과 그것을 실현하기 위한 체계적인 전략 수립에 탁월합니다. 복잡한 문제를 분석하고 혁신적인 해결책을 도출하는 것을 즐깁니다.

실제 생활에서는 뛰어난 통찰력과 전략적 사고가 돋보입니다. 예를 들어, 조직의 비효율적인 시스템을 파악하고 개선 방안을 제시하거나, 복잡한 프로젝트의 장기적 방향성을 수립하는 데 탁월한 능력을 보입니다. 또한 독립적인 작업 환경에서 자신의 전문성을 발휘하며 혁신적인 아이디어를 실현시키는 것을 선호합니다.

하지만 자신의 높은 기준과 완벽주의적 성향으로 인해 타인과의 협업에서 어려움을 겪을 수 있습니다. 특히 감정적인 교류나 일상적인 사교 활동을 불필요하게 여기는 경향이 있으며, 다른 사람들의 비효율적인 업무 방식이나 논리적이지 않은 결정에 강한 불만을 느낍니다. 또한 자신의 비전을 타인과 효과적으로 공유하는 것을 어려워할 수 있습니다.`,
    development: [
      "타인의 감정과 관점을 이해하려 노력하고 공감을 표현하세요",
      "완벽한 계획보다 실행과 조정의 균형을 찾으세요",
      "다른 사람들과의 협업과 소통에 더 많은 관심을 기울이세요",
      "즉흥적인 상황이나 계획의 변경도 수용하는 법을 배우세요"
    ]
  }
};